import React from "react";
import ImgLogo from "../../public/assets/main-logo.svg";
import Link from "next/link";
import Image from "next/image";

export default function MainLogo({ fill }) {
  return (
    <div className="MainLogo">
      <Link href="/" aria-label="Logo eternal slots">
        <Image
          src={ImgLogo.src}
          alt="goat spins"
          width={200}
          height={30}
          priority
        />
      </Link>
    </div>
  );
}
